module.exports = __webpack_public_path__ + "img/611.58a0c424.jpg";